import { Flex, Spacing } from '@billy/design-system'

import { isMac } from '../../../../../utils/isMac'
import { ShortcutItem } from './ShortcutItem'
import * as Styled from './styles'

export const ResultsFooter = () => (
  <Styled.ResultsFooterWrapper>
    <Flex as="ul" alignItems="center" justifyContent="space-around" width="100%" gap={Spacing.S16}>
      <ShortcutItem
        icons={[{ icon: 'chevronUp' }, { icon: 'chevronDown' }]}
        translationKey="global_search.results_footer.to_navigate"
      />

      <ShortcutItem icons={[{ icon: 'undo' }]} translationKey="global_search.results_footer.to_select" />

      <ShortcutItem icons={[{ label: 'esc' }]} translationKey="global_search.results_footer.to_dismiss" />

      <ShortcutItem
        icons={[{ label: isMac ? 'cmd' : 'ctrl' }, { label: 'O' }]}
        translationKey="organization_search.results_footer.open_all_org"
      />
    </Flex>
  </Styled.ResultsFooterWrapper>
)
